import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33e87ba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid py-5 px-0" }
const _hoisted_2 = { class: "container px-2" }
const _hoisted_3 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_4 = { class: "text-center fw-bold heading mb-3 mb-lg-5" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = { class: "col-lg-8 mb-3 mb-lg-5 px-0" }
const _hoisted_8 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fs-7 px-0" }
const _hoisted_10 = { class: "mx-0 px-0 col-lg-8" }
const _hoisted_11 = {
  for: "img",
  class: "input-group-text cursor-pointer fs-75"
}
const _hoisted_12 = { class: "d-flex py-2 mb-0" }
const _hoisted_13 = { class: "fs-75 mx-0 px-0" }
const _hoisted_14 = {
  key: 0,
  class: "user-avatar mt-4 position-relative d-lg-inline-block d-flex justify-content-center"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "border-bottom row mx-0 px-0 gx-3 pb-4 mb-4" }
const _hoisted_19 = { class: "w-max-content col-lg-2 col-form-label text-black ps-0 fs-7" }
const _hoisted_20 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_21 = { class: "mx-0 px-0 col-lg-8" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_26 = { class: "col-lg-4 col-form-label fs-7 ps-0" }
const _hoisted_27 = { class: "mx-0 px-0 col-lg-8" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "border-bottom row mx-0 px-0 mb-4" }
const _hoisted_32 = { class: "col-lg-4 col-form-label fs-7 gx-3 ps-0" }
const _hoisted_33 = { class: "col-lg-8 row align-items-center mb-4 gx-0" }
const _hoisted_34 = {
  class: "col-lg-7 fs-7 text-lg-start text-center cursor-pointer text-decoration-underline hover-link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#editProfileModal"
}
const _hoisted_35 = { class: "col-lg-5 text-lg-start text-center" }
const _hoisted_36 = { class: "border-bottom row mx-0 px-0 mb-4 gx-3" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fs-7 ps-0" }
const _hoisted_38 = { class: "d-flex align-items-center col-lg-8 py-2" }
const _hoisted_39 = ["for"]
const _hoisted_40 = ["id", "value"]
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-lg-4" }, null, -1))
const _hoisted_43 = {
  key: 0,
  class: "fs-75 col-lg-8"
}
const _hoisted_44 = { class: "border-bottom row mx-0 px-0 gx-3 mb-4" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fs-7 ps-0" }
const _hoisted_46 = { class: "col-lg-8 py-2" }
const _hoisted_47 = { class: "d-flex align-items-center px-0" }
const _hoisted_48 = { class: "form-check form-switch" }
const _hoisted_49 = {
  class: "form-check-label cursor-pointer fs-7",
  for: "$settingComment"
}
const _hoisted_50 = { class: "form-check form-switch ms-5" }
const _hoisted_51 = {
  class: "form-check-label cursor-pointer fs-7",
  for: "$settingInterested"
}
const _hoisted_52 = { class: "fs-75 pt-3 text-left gx-0 ps-lg-2 ps-0" }
const _hoisted_53 = { class: "border-bottom row mx-0 px-0 gx-3 mb-4" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fs-7 ps-0" }
const _hoisted_55 = { class: "col-lg-8 py-2" }
const _hoisted_56 = { class: "d-flex align-items-center px-0" }
const _hoisted_57 = { class: "form-check form-switch" }
const _hoisted_58 = {
  class: "form-check-label cursor-pointer fs-7",
  for: "$settingChatting"
}
const _hoisted_59 = { class: "form-check form-switch ms-5" }
const _hoisted_60 = {
  class: "form-check-label cursor-pointer fs-7",
  for: "$settingMention"
}
const _hoisted_61 = { class: "fs-75 pt-3 text-left gx-0 ps-lg-2 ps-0" }
const _hoisted_62 = { class: "border-bottom row mx-0 px-0 gx-3 mb-4" }
const _hoisted_63 = { class: "col-lg-4 col-form-label fs-7 ps-0" }
const _hoisted_64 = { class: "col-lg-8 py-2" }
const _hoisted_65 = { class: "d-flex align-items-center px-0" }
const _hoisted_66 = { class: "form-check form-switch" }
const _hoisted_67 = {
  class: "form-check-label cursor-pointer fs-7",
  for: "$emailNotification"
}
const _hoisted_68 = { class: "fs-75 pt-3 text-left gx-0 ps-lg-2 ps-0" }
const _hoisted_69 = { class: "text-center fs-7" }
const _hoisted_70 = { class: "text-center text-lg-end fs-7" }
const _hoisted_71 = { class: "row flex-column-reverse flex-lg-row" }
const _hoisted_72 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_73 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_74 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "modalConfirm",
  "aria-hidden": "true"
}
const _hoisted_75 = { class: "modal-dialog" }
const _hoisted_76 = { class: "modal-content p-4" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_78 = { class: "content mx-auto" }
const _hoisted_79 = { class: "my-5 text-center" }
const _hoisted_80 = { class: "row flex-column-reverse flex-lg-row" }
const _hoisted_81 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_82 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_83 = {
  class: "modal fade",
  id: "modalFinish",
  tabindex: "-1",
  "aria-labelledby": "modalFinish",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog" }
const _hoisted_85 = { class: "modal-content p-4" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_87 = { class: "content mx-auto" }
const _hoisted_88 = { class: "my-5 text-center" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-lg-12 d-flex justify-content-center mb-4 mb-lg-0" }

import { ref, computed, watchEffect, ComputedRef, watch, onMounted, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { countCharInSurrogatePair, customMaxLength, scrollToErrors } from '@/utils'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import Status from '@/components/status/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import BasicInformation from '@/views/user/account/profile/setting/components/BasicInformation.vue'

import { DEFAULT_MAX_JP_TEXT, MAX_WORD, MAX_UPLOAD_FILE_SIZE_BYTES, MAX_UPLOAD_FILE_SIZE_MB } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import { ACCOUNT_STORE, COMMUNITY_STORE, ROOT_STORE } from '@/store/constants'
import { translate } from '@/languages/i18n'
import { ID } from './languages/ID'
import userServices from '@/services/users.service'
import { buildFormData, buildImgUrl } from '@/utils'
import { CommunityStateTypes } from '@/store/modules/community'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { getMessage, ERROR_SETTINGS_ALREADY_UPDATED } from '@/constants/messageCode'
import { addUserIconParams, userType } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()

const notSelected = translate('notSelected')
const updateError = translate('SG40updateError')
const errorMessage = ref<string>(updateError)
const file = ref(null)
const fileData = ref(null)
const fileType = ref(null)
const fileUrl = ref(null)
const fileName = ref<string>(notSelected)
const imageChange = ref<boolean>(false)
const isSubmitting = ref<boolean>(false)
const serverError = ref<boolean>(false)
const modal = ref()
const modalConfirm = ref()

const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const showLimitedDescription = computed<ComputedRef<boolean>>(() => me.value?.limited)

watch(
  [() => me.value?.alumni_user_id, () => router.currentRoute.value.params?.id],
  () => {
    if (me.value?.alumni_user_id && router.currentRoute.value.params?.id) {
      store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id: router.currentRoute.value.params.id, userID: me.value?.alumni_user_id, userType: 'alumni' })
    }
  },
  { immediate: true }
)

onMounted(() => {
  modal.value = new Modal(document.getElementById('modalFinish'))
  modalConfirm.value = new Modal(document.getElementById('modalConfirm'))
})

const radioList = computed(() => {
  return [
    {
      title: translate('SG40show'),
      publicTitle: translate('public'),
      showPublicTitle: true,
      mailTitle: translate(`${ID}receiveMail`),
      value: 1,
      status: true,
    },
    {
      title: translate('SG40notShow'),
      publicTitle: translate('limitPublic'),
      showPublicTitle: me.value?.limited,
      mailTitle: translate(`${ID}notReceiveMail`),
      value: 2,
      status: false,
    },
    {
      title: translate('private'),
      publicTitle: translate('private'),
      showPublicTitle: me.value?.closed,
      value: 3,
    },
  ]
})

const rules = computed(() => {
  return {
    display_name: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    introduction: {
      textAreaMaxLength: function (value) {
        if (!value) return true
        return countCharInSurrogatePair(value) <= MAX_WORD
      },
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    image_url: {
      checkTypeImage: function (value) {
        if (value) {
          return ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type)
        }
        return true
      },
      fileSizeValidation: function (value) {
        if (value) {
          return value.size <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
    },
    profile_n_portfolio_published: {},
    email_notice: {},
    email_notice_setting_comment: {},
    email_notice_setting_mention: {},
    email_notice_setting_chatting: {},
    email_notice_setting_interested: {},
  }
})

const formData = ref({
  display_name: me.value?.profile?.display_name,
  introduction: '',
  profile_n_portfolio_published: me.value?.profile?.profile_n_portfolio_published,
  email_notice: me.value?.profile?.email_notice,
  image_url: '',
  email_notice_setting_comment: me.value?.profile?.email_notice_setting_comment,
  email_notice_setting_mention: me.value?.profile?.email_notice_setting_mention,
  email_notice_setting_chatting: me.value?.profile?.email_notice_setting_chatting,
  email_notice_setting_interested: me.value?.profile?.email_notice_setting_interested,
})

watchEffect(() => {
  formData.value = {
    display_name: me.value?.profile?.display_name,
    introduction: me.value?.profile?.introduction,
    profile_n_portfolio_published: me.value?.profile?.profile_n_portfolio_published,
    email_notice: me.value?.profile?.email_notice,
    email_notice_setting_comment: me.value?.profile?.email_notice_setting_comment,
    email_notice_setting_mention: me.value?.profile?.email_notice_setting_mention,
    email_notice_setting_chatting: me.value?.profile?.email_notice_setting_chatting,
    email_notice_setting_interested: me.value?.profile?.email_notice_setting_interested,
  }

  fileData.value = me.value?.profile?.image_url
})

watchEffect(() => {
  if (typeof me.value?.profile?.image_url !== 'string' && me.value?.profile?.image_url) {
    fileUrl.value = URL.createObjectURL(me.value?.profile?.image_url)
    return
  } else {
    fileUrl.value = me.value?.profile?.image_url
  }
})
const v$ = useVuelidate(rules, formData)

const handleChangeFile = async (): void => {
  const { newFileUrl, newFile } = await buildImgUrl(file.value.files[0])
  fileUrl.value = newFileUrl
  fileData.value = newFile
  fileType.value = newFile?.type
  fileName.value = newFile?.name

  imageChange.value = true

  v$.value.image_url.$model = file.value.files[0]
}

const handleFile = (event) => {
  event.target.value = ''
}

const removeAvatar = (): void => {
  imageChange.value = true
  file.value = null
  fileUrl.value = null
  fileData.value = null
  fileName.value = notSelected
  fileType.value = null
  v$.value.image_url.$model = ''
}

const handleConfirm = async (): Promise<void> => {
  v$.value.$touch()
  isCheckedNGDisplayName.value = false
  isCheckedNGIntroduction.value = false
  await checkNGDisplayName()
  await checkNGIntroduction()

  while (!isCheckedNGDisplayName.value || !isCheckedNGIntroduction.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyIntroduction.value || ngKeyDisplayName.value) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  modalConfirm.value?.show()
}

const onSubmit = async (): Promise<void> => {
  isSubmitting.value = true
  const formSubmit = new FormData()

  buildFormData(formSubmit, {
    display_name: formData.value?.display_name,
    introduction: formData.value?.introduction,
    profile_n_portfolio_published: formData.value?.profile_n_portfolio_published,
    email_notice: formData.value?.email_notice,
    email_notice_setting_comment: formData.value?.email_notice_setting_comment,
    email_notice_setting_mention: formData.value?.email_notice_setting_mention,
    email_notice_setting_chatting: formData.value?.email_notice_setting_chatting,
    email_notice_setting_interested: formData.value?.email_notice_setting_interested,
  })

  if (!fileData.value && imageChange.value) {
    formSubmit.append('remove_image', true)
  } else if (imageChange.value) {
    formSubmit.append('image', fileData.value)
  }
  try {
    const response = await userServices.updateProfileCommunityAlumni({
      id: router.currentRoute.value.params.id,
      formData: formSubmit,
    })

    if (response?.status === 200) {
      store.dispatch(COMMUNITY_STORE.ACTIONS.UPDATE_ME, {
        ...me?.value,
        profile: {
          ...formData.value,
          family_name: me.value?.profile?.family_name,
          given_name: me.value?.profile?.given_name,
          family_name_kana: me.value?.profile?.family_name_kana,
          given_name_kana: me.value?.profile?.given_name_kana,
          birthday: me.value?.profile?.birthday,
          email: me.value?.profile?.email,
          institution: me.value?.profile?.institution,
          job_type_child: me.value?.profile?.job_type_child,
          job_type_parent: me.value?.profile?.job_type_parent,
          enrollment_start_period: me.value?.profile?.enrollment_start_period,
          image_url: fileData.value && typeof fileData.value !== 'string' ? URL.createObjectURL(fileData.value) : fileData.value,
        },
      })
      store.dispatch(COMMUNITY_STORE.ACTIONS.CHANGE_IMAGE_URL_ME, {
        community_management_id: response.data?.body?.community_management_id,
        image_url: fileData.value && typeof fileData.value !== 'string' ? URL.createObjectURL(fileData.value) : fileData.value,
      })
      isSubmitting.value = false
      serverError.value = false
      fileData.value = null
    } else {
      serverError.value = true
      isSubmitting.value = false
      if (response.response?.data?.data[0]?.message_code === ERROR_SETTINGS_ALREADY_UPDATED) {
        errorMessage.value = getMessage(response.response?.data?.data[0]?.message_code)
      }
    }
    modal.value?.show()
    modalConfirm.value?.hide()
    imageChange.value = false
  } catch (error) {
    isSubmitting.value = false
    serverError.value = true
    console.log(error)
  }
}

const transitPortfolioSetting = () => {
  router.push(`/alumni/communities/${router.currentRoute.value.params.id}/account/portfolio/setting`)
}
const backScreen = () => {
  router.push(`/alumni/communities/${router.currentRoute.value.params.id}`)
}

const isCheckedNGDisplayName = { value: false }
const ngKeyDisplayName = ref<boolean>(false)
const checkNGDisplayName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.display_name.$model })
  ngKeyDisplayName.value = data.data?.data?.has_ngword
  isCheckedNGDisplayName.value = true
}, 200)

const isCheckedNGIntroduction = { value: false }
const ngKeyIntroduction = ref<boolean>(false)
const checkNGIntroduction = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.introduction.$model })
  ngKeyIntroduction.value = data.data?.data?.has_ngword
  isCheckedNGIntroduction.value = true
}, 200)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(translate)(`${_unref(ID)}heading`)), 1),
          _createVNode(BasicInformation),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  class: "mx-auto",
                  onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('profileImage')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        type: "file",
                        ref: (_value, _refs) => {
                          _refs['file'] = _value
                          file.value = _value
                        },
                        class: "d-none",
                        id: "img",
                        accept: "image/png, image/jpeg, image/jpg",
                        onChange: handleChangeFile,
                        onClick: handleFile
                      }, null, 544),
                      _createElementVNode("div", {
                        class: _normalizeClass(['input-group', _unref(v$).image_url.$error ? 'is-invalid' : ''])
                      }, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('selectFile')), 1),
                        _createElementVNode("label", {
                          class: _normalizeClass(['form-control cursor-pointer text-truncate fs-7', fileName.value === _unref(notSelected) ? 'text-place' : '']),
                          for: "img"
                        }, _toDisplayString(fileName.value), 3)
                      ], 2),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", null, _toDisplayString(_unref(translate)('SG40infoImage')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(translate)('SG40infoImage1')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(translate)('SG40infoImage2')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(translate)('SG40infoImage3')), 1)
                        ])
                      ]),
                      ((fileUrl.value && !fileType.value) || ['image/png', 'image/jpeg', 'image/jpg'].includes(fileType.value))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("img", {
                              src: _unref(addUserIconParams)(fileUrl.value!, _unref(userType)()),
                              alt: "user avatar",
                              class: "rounded-circle"
                            }, null, 8, _hoisted_15),
                            _createElementVNode("div", {
                              onClick: removeAvatar,
                              class: "position-absolute"
                            }, _hoisted_17)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('profileImage'),
                        validator: _unref(v$).image_url.$errors[0]?.$validator,
                        params: [_unref(MAX_UPLOAD_FILE_SIZE_MB)]
                      }, null, 8, ["title", "validator", "params"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('nickName')), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(Status)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).display_name.$model) = $event)),
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGDisplayName) && _unref(checkNGDisplayName)(...args))),
                          class: _normalizeClass(['form-control', ngKeyDisplayName.value || _unref(v$).display_name.$error ? 'is-invalid' : '']),
                          placeholder: _unref(translate)('placeholder'),
                          name: "nickName"
                        }, null, 42, _hoisted_23), [
                          [
                            _vModelText,
                            _unref(v$).display_name.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (ngKeyDisplayName.value && !_unref(v$).display_name.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                          : _createCommentVNode("", true),
                        _createVNode(InputErrorMessage, {
                          title: 'nickName',
                          params: [1, 20],
                          validator: _unref(v$).display_name.$errors[0]?.$validator
                        }, null, 8, ["validator"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)(`${_unref(ID)}introduction`)), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("textarea", {
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).introduction.$model) = $event)),
                          class: _normalizeClass(['form-control', ngKeyIntroduction.value || _unref(v$).introduction.$error ? 'is-invalid' : '']),
                          placeholder: _unref(translate)('placeholder'),
                          name: "'introduction'",
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGIntroduction) && _unref(checkNGIntroduction)(...args)))
                        }, null, 42, _hoisted_29), [
                          [
                            _vModelText,
                            _unref(v$).introduction.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (ngKeyIntroduction.value && !_unref(v$).introduction.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                          : _createCommentVNode("", true),
                        _createVNode(InputErrorMessage, {
                          title: `${_unref(ID)}introduction`,
                          params: [1, 100],
                          validator: _unref(v$).introduction.$errors[0]?.$validator
                        }, null, 8, ["title", "validator"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(translate)('portfolio')), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(translate)(`${_unref(ID)}checkPortfolio`)), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(Button, {
                          title: _unref(translate)(`${_unref(ID)}portfolioSetting`),
                          type: 'secondary',
                          size: 'small',
                          onClick: transitPortfolioSetting
                        }, null, 8, ["title"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(translate)('profileSetting')), 1),
                    _createElementVNode("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(radioList).filter((item) => item.showPublicTitle), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass([_unref(isMobile) ? 'col-2' : 'col-3', "form-check me-5"]),
                          key: item.publicTitle
                        }, [
                          _createElementVNode("label", {
                            class: "form-check-label fs-7 text-nowrap cursor-pointer",
                            for: `$publishing${index}`
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "form-check-input",
                              id: `$publishing${index}`,
                              value: item.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).profile_n_portfolio_published.$model) = $event))
                            }, null, 8, _hoisted_40), [
                              [_vModelRadio, _unref(v$).profile_n_portfolio_published.$model]
                            ]),
                            _createTextVNode(" " + _toDisplayString(item.publicTitle), 1)
                          ], 8, _hoisted_39)
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      (_unref(showLimitedDescription))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_unref(translate)(`${_unref(ID)}limit`)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('SG40ActionNoticeSetting')), 1),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "$settingComment",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).email_notice_setting_comment.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _unref(v$).email_notice_setting_comment.$model]
                          ]),
                          _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)(`${_unref(ID)}settingComment`)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "$settingInterested",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).email_notice_setting_interested.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _unref(v$).email_notice_setting_interested.$model]
                          ]),
                          _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(translate)(`${_unref(ID)}settingInterested`)), 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(translate)(`${_unref(ID)}actionNoticeSettingDes`)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)('SG40chatMentionNoticeSetting')), 1),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "$settingChatting",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).email_notice_setting_chatting.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _unref(v$).email_notice_setting_chatting.$model]
                          ]),
                          _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(translate)(`${_unref(ID)}settingChatting`)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "$settingMention",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).email_notice_setting_mention.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _unref(v$).email_notice_setting_mention.$model]
                          ]),
                          _createElementVNode("label", _hoisted_60, _toDisplayString(_unref(translate)(`${_unref(ID)}settingMention`)), 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_61, _toDisplayString(_unref(translate)(`${_unref(ID)}chatMentionNoticeSettingDes`)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(translate)('emailNotificationUnread')), 1),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "$emailNotification",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).email_notice.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _unref(v$).email_notice.$model]
                          ]),
                          _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(translate)(`${_unref(ID)}receiveMail`)), 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_68, _toDisplayString(_unref(translate)(`${_unref(ID)}emailNotice`)), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_69, _toDisplayString(_unref(translate)(`${_unref(ID)}memoUpdate`)), 1),
                  _createElementVNode("p", _hoisted_70, [
                    _createTextVNode(_toDisplayString(_unref(translate)('leaveCommunity')) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: `/${_unref(route)?.path?.split('/')[1]}/communities/${_unref(route)?.params?.id}/leave_community`,
                      class: "link hover-link cursor-pointer"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)('here')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(Button, {
                        title: _unref(translate)(`${_unref(ID)}top`),
                        type: 'secondary',
                        onClick: backScreen
                      }, null, 8, ["title"])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(Button, {
                        class: "button-submit",
                        title: _unref(translate)('update'),
                        type: 'secondary',
                        onClick: handleConfirm,
                        disabled: _unref(v$).$invalid || ngKeyIntroduction.value || ngKeyDisplayName.value
                      }, null, 8, ["title", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _hoisted_77,
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("p", _hoisted_79, _toDisplayString(_unref(translate)(`${_unref(ID)}updateYourProfile`)), 1),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createVNode(Button, {
                                title: _unref(translate)('cancel'),
                                type: 'secondary',
                                "data-bs-dismiss": 'modal'
                              }, null, 8, ["title"])
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                              _createVNode(Button, {
                                title: '更新する',
                                type: 'secondary',
                                onClick: onSubmit,
                                loading: isSubmitting.value,
                                disabled: isSubmitting.value,
                                class: "button-submit"
                              }, null, 8, ["loading", "disabled"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 32)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _hoisted_86,
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("p", _hoisted_88, _toDisplayString(_unref(translate)(serverError.value ? errorMessage.value : `${_unref(ID)}updateFinished`)), 1),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createVNode(Button, {
                  title: _unref(translate)('close'),
                  type: 'secondary',
                  "data-bs-dismiss": 'modal'
                }, null, 8, ["title"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})